import axios from 'axios'
import {
  Message
} from 'element-ui'
import qs from 'qs'
import { getAppKey } from '@/utils/auth'
import router from '../router'
import store from '@/store'
// import configInfo from '@/utils/config'
const http = axios.create({
  timeout: 1000 * 30,
  withCredentials: true
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  // 全局token
  const token = store.state.auth.token
  if (token) {
    config.headers['token'] = token
  }

  // 处理参数格式，默认为json格式，如需为formdata格式，则处理
  if (config.data && config.type === 'json') {
    config.headers['Content-Type'] = 'application/json'
  } else {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    config.transformRequest = function (data, headers) {
      // 如果数据本身为FormData文件上传格式，则不处理。
      if (Object.prototype.toString.call(data) === '[object FormData]') return data
      for (var key in data) { // 处理json值
        const value = data[key]
        // util.isObject(value) ? data[key] = JSON.stringify(value) : ''; //处理对象
        // eslint-disable-next-line no-unused-expressions
        Array.isArray(value) && value.length === 0 ? data[key] = null : '' // 处理空数组
      }
      const ret = data ? qs.stringify(data, {
        arrayFormat: 'indices',
        allowDots: true,
        indices: false
      }) : ''
      return ret
    }
  }

  return config
}, error => {
  return Promise.reject(error)
})

http.interceptors.response.use(
  response => {
    const res = response.data
    // 如果是获取token接口 直接返回
    if (res.access_token) {
      return response
    }
    if (parseInt(res.code) !== 0) {
      // token 过期
      if (res.code === -1000) {
        store.dispatch('userLogout')
        router.push({
          name: 'userLogin'
        })
      } else {
        const config = response.config

        let params = config.params || config.data
        if (config.type === 'json' && params) {
          params = JSON.parse(params)
        }
        // NO_TOAST为1时，http不自动显示报错信息提示
        if (!params.NO_TOAST) {
          Message({
            message: res.msg,
            type: 'error',
            duration: 5 * 1000
          })
        }

        return response.data
      }
    } else {
      return response.data
    }
  },
  error => {
    console.log(error)
    console.log(error.response)
    if (error.response.status === 500) {
      store.dispatch('userLogout')
      router.push({
        name: 'userLogin'
      })
      Message({
        message: '登陆失效',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)
    }
    Message({
      message: '网络异常',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

function request (method, url, params = {}, type = '', kylinTenant = null, ticket = null) {
  // if (kylinTenant !== null) {
  //   http.defaults.headers['appkey'] = kylinTenant
  // } else {
  //   http.defaults.headers.hasOwnProperty('appkey') && delete http.defaults.headers.appkey
  // }
  const appkey = getAppKey()
  if (appkey !== 'undefined' && appkey !== undefined) {
    http.defaults.headers['appkey'] = appkey
  }
  if (ticket !== null) {
    http.defaults.headers['token'] = ticket
  } else {
    http.defaults.headers.hasOwnProperty('token') && delete http.defaults.headers.token
  }
  if (params && params.extra) {
    url = url + '/' + params.extra
    delete params.extra
  }
  let options = {
    method,
    url,
    type
  }
  options.method === 'get' ? options.params = params : options.data = params
  return new Promise((resolve, reject) => {
    http(options).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

function post (url, params = {}, type = '', kylinTenant = null, ticket = null) {
  return request('post', arguments[0], arguments[1], arguments[2], arguments[3], arguments[4])
}

function put (url, params = {}, type = '', kylinTenant = null, ticket = null) {
  return request('put', arguments[0], arguments[1], arguments[2], arguments[3], arguments[4])
}

function get (url, params = {}, kylinTenant = null, ticket = null) {
  return request('get', arguments[0], arguments[1], '', arguments[2], arguments[3])
}

function del (url, params = {}, kylinTenant = null, ticket = null) {
  return request('delete', arguments[0], arguments[1], '', arguments[2], arguments[3], arguments[4])
}

export default {
  post,
  get,
  del,
  put
}



// WEBPACK FOOTER //
// ./src/utils/http.js